import React from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './styles.css';
import { AppLayout } from './ui/AppLayout';
import { HomePage } from './pages/HomePage';
import { CategoryPage } from './pages/CategoryPage';
import { PostPage } from './pages/PostPage';
import { AdminLoginPage } from './pages/admin/AdminLoginPage';
import { AdminDashboardPage } from './pages/admin/AdminDashboardPage';

const router = createBrowserRouter([
  {
    path: '/',
    element: <AppLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'kategori/:slug', element: <CategoryPage /> },
      { path: 'yazi/:slug', element: <PostPage /> },
    ],
  },
  { path: '/__admin', element: <AdminLoginPage /> },
  { path: '/__admin/panel', element: <AdminDashboardPage /> },
]);

const container = document.getElementById('root');
if (!container) throw new Error('Root bulunamadı');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);


